/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COMMENTING ANALYTICS - EMAILS SENT REPORT : STYLES --------------- ++++++++++ */
export default {
    emailsSentReport: {
        marginBottom: pxToEm(16),
        marginTop: pxToEm(16),
    }
};
